import React from "react";
import styled from "styled-components";
import info2 from "assets/info2.svg";
import chevronRightIcon from "assets/icons/lesson-report/chevron-right.svg";
import { Tooltip } from "components/shared/Tooltip/Tooltip";
import { COLLAB_RUBRIC_LEVELS_URL } from "constants/rubricLinks";
import { colors } from "utils";

export const COLLAB_LEVEL_INFO_COPY =
  "Collaboration measures how the group explains reasoning, responds to teammates, and builds on each other's ideas. Students see this as their Teamwork Score.";

// The (i) beside a Collaboration Level in the session report. One explanation for
// every level, with the rubric a click away, in the same hover card the lesson
// report uses for its student tooltips.
export const CollabLevelInfo = ({ id }) => (
  <Tooltip
    interactive
    placement="top"
    maxWidth={312}
    background={colors.blue50}
    id={id}
    tip={
      <TipBody>
        <TipCopy>{COLLAB_LEVEL_INFO_COPY}</TipCopy>
        <TipLink href={COLLAB_RUBRIC_LEVELS_URL} target="_blank" rel="noopener noreferrer">
          See the Collaboration Rubric
          <img src={chevronRightIcon} alt="" aria-hidden="true" />
        </TipLink>
      </TipBody>
    }
  >
    <InfoTrigger type="button" aria-label="About Collaboration Level" aria-describedby={id}>
      <img src={info2} alt="" aria-hidden="true" />
    </InfoTrigger>
  </Tooltip>
);

const InfoTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  background: none;
  border: 0;
  padding: 0;
  margin-left: 4px;
  cursor: help;
  vertical-align: middle;

  img {
    width: 16px;
    height: 16px;
  }
`;

const TipBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 280px;
  text-align: left;
  color: ${colors.nightlyWoods500};
`;

const TipCopy = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
`;

const TipLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 48px;
  padding: 0 8px 0 16px;
  border: 1px solid ${colors.blue500};
  border-radius: 8px;
  background: #fff;
  color: ${colors.blue500};
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.25px;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: ${colors.blue700};
    border-color: ${colors.blue700};
  }

  img {
    width: 24px;
    height: 24px;
  }
`;
